<template>
    <div class="w-100 pt5">
        <div class="bg-white bottom-0" :class="$tachyons.bottomBar" v-if="pagina.hay_prev || pagina.hay_sig">
            <div :class="$tachyons.center" class="w-100 w-80-ns flex items-center justify-between ph3 ph0-ns">
                <div class="h-100 flex items-center ph3 tc b--near-white pv1" @click="navegar(pagina.prev)" >
                    <inline-svg v-if="pagina.hay_prev" class="w2 fill-blue" src="img/fa/chevron-left.svg"/>
                </div>
                <div class="h-100 flex items-center ph3 tc b--near-white pv1 pointer" @click="navegar(pagina.sig)">
                    <inline-svg v-if="pagina.hay_sig" class="w2 fill-blue" src="img/fa/chevron-right.svg"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'paginacion',
        props: {
            borde: {
                type: String,
                default: ''
            },
            pagina: {
                type: Object,
                default: () => { return {}; },
            },
        },
        mounted () {
        },
        methods: {
            navegar (p){
                var parametros = JSON.parse( JSON.stringify(this.$route.query) );
                    parametros.pagina = p;
                this.$router.push({query: parametros });
                this.$emit('cambio', p);
            },
        },
        data () {
            return {
                // paginacion: {},
            }
        },
    }
</script>
<style lang="css">
</style>
